import { getPackageType } from 'src/common/stores/multi-item-store-util';
import { DEFAULT_ADMIN_PWA_PAGE_ID, DEFAULT_ADMIN_PWA_PAGE_NAME, DEFAULT_GT_SEARCH_PAGE_ID, DEFAULT_GT_SEARCH_PAGE_NAME, DEFAULT_HOTEL_HOME_PAGE_ID, DEFAULT_HOTEL_HOME_PAGE_NAME, DEFAULT_HOTEL_INFOSITE_PAGE_ID, DEFAULT_HOTEL_INFOSITE_PAGE_NAME, DEFAULT_HOTEL_SEARCH_PAGE_ID, DEFAULT_HOTEL_SEARCH_PAGE_NAME, DetailsClickstreamPageNameDetailed, INFOSITE_PAGE_EG_CLICKSTREAM_NAME, InfositePageName, SEARCH_PAGE_EG_CLICKSTREAM_NAME, SearchClickstreamPageNameDetailed, SearchPageName } from 'src/common/constants/pages';
export function getHotelSearchPageData(query) {
  const packageType = getPackageType(query);
  if (!packageType) {
    return {
      navigationId: 'hotel',
      clickstreamPageName: SEARCH_PAGE_EG_CLICKSTREAM_NAME,
      clickstreamPageNameDetailed: SearchClickstreamPageNameDetailed.SA,
      pageName: DEFAULT_HOTEL_SEARCH_PAGE_NAME,
      pageId: DEFAULT_HOTEL_SEARCH_PAGE_ID
    };
  }
  const pageName = SearchPageName[packageType];
  const pageId = `${pageName},P,20`;
  return {
    pageName,
    pageId,
    navigationId: 'package',
    clickstreamPageName: SEARCH_PAGE_EG_CLICKSTREAM_NAME,
    clickstreamPageNameDetailed: SearchClickstreamPageNameDetailed[packageType]
  };
}
export const getHotelInfositePageData = query => {
  const packageType = getPackageType(query);
  if (!packageType) {
    return {
      navigationId: 'hotel',
      clickstreamPageName: INFOSITE_PAGE_EG_CLICKSTREAM_NAME,
      clickstreamPageNameDetailed: DetailsClickstreamPageNameDetailed.SA,
      pageName: DEFAULT_HOTEL_INFOSITE_PAGE_NAME,
      pageId: DEFAULT_HOTEL_INFOSITE_PAGE_ID
    };
  }
  const pageName = InfositePageName[packageType];
  const pageId = `${pageName},P,30`;
  return {
    pageName,
    pageId,
    navigationId: 'package',
    clickstreamPageName: INFOSITE_PAGE_EG_CLICKSTREAM_NAME,
    clickstreamPageNameDetailed: DetailsClickstreamPageNameDetailed[packageType]
  };
};
export const getHotelHomePageData = () => {
  const pageName = DEFAULT_HOTEL_HOME_PAGE_NAME;
  const pageId = DEFAULT_HOTEL_HOME_PAGE_ID;
  return {
    pageName,
    pageId
  };
};
export const getGroundTransportationSearchPageData = () => {
  const pageName = DEFAULT_GT_SEARCH_PAGE_NAME;
  const pageId = DEFAULT_GT_SEARCH_PAGE_ID;
  return {
    pageName,
    pageId
  };
};
export const getAdminPwaPageData = () => {
  const pageName = DEFAULT_ADMIN_PWA_PAGE_NAME;
  const pageId = DEFAULT_ADMIN_PWA_PAGE_ID;
  return {
    pageName,
    pageId
  };
};